<template>
  <sui-segment emphasis="secondary">
    <sui-form-fields>
      <sui-form-field :width="7">
        <label>Service</label>
        <sui-dropdown class="disabled" selection :options="servicesList" v-model="entity.id" />
      </sui-form-field>
      <sui-form-field :width="7">
        <label>Log provider</label>
        <sui-dropdown search selection :options="logProvidersList" v-model="logProvider" />
      </sui-form-field>
      <sui-form-field :width="2">
        <label style="opacity: 0">.</label>
        <div class="ui tiny icon fluid button" :class="{disabled: !access.providerCreate}" data-inverted data-position="left center" data-tooltip="Add new provider" @click.prevent="$modals.createProvider.open({type: 'gelf'}, onCreateProvider)" data-goal="SERVICE_FORM_NEW_PROVIDER">
          <i class="ui large fitted icons">
            <i class="cloud fitted icon" />
            <i class="inverted corner plus fitted icon" />
          </i>
        </div>
      </sui-form-field>
    </sui-form-fields>
    <sui-message style="display: flex;" v-if="!$attrs.value">
      All logs of the service containers will be collected by D2C.<br>
      You will be able to see them in the D2C interface.
    </sui-message>
    <sui-message warning style="display: flex;" v-if="$attrs.value">
      All new logs of the service containers will be send to the selected log provider.<br>
      You won't be able to see them in the D2C interface.
    </sui-message>
  </sui-segment>
</template>

<script>
  import {mapGetters} from 'vuex'
  import FormField from '@/mixins/FormField'
  import logos from '@/logos'

  export default {
    name: 'FormServiceHosts',
    mixins: [
      FormField,
    ],
    data() {
      return {
        logProvider: `${this.$attrs.value}`,
      }
    },
    computed: {
      ...mapGetters(['access', 'providers', 'services']),
      servicesList() {
        return this.services.map(service => {
          return {
            image: {src: service._logo},
            text: service.name,
            value: service.id,
          }
        })
      },
      logProvidersList() {
        return [
          {
            value: 'null',
            text: 'Default log provider',
            image: {src: logos.providers.D2C}
          },
          ...this.providers.filter(provider => provider.purpose === 'logs').map(provider => {
            return {
              value: provider.id,
              text: provider.name,
              image: {src: provider._logo},
            }
          })
        ]
      },
    },
    watch: {
      logProvider(value) {
        this.set(value === 'null' ? null : value)
      },
    },
    methods: {
      onCreateProvider(result) {
        if (result && result.id) {
          this.logProvider = result.id
        }
      },
    }
  }
</script>
